import {SxProps, Theme} from '@mui/material'

import {type CardBoxSize} from '../types'

export const LayoutConstants = {
  DEFAULT_CONTENT_WIDTH: 1280,
  MIN_CONTENT_WIDTH: 1024
}

export const BOX_WIDTHS: Record<CardBoxSize, string> = {
  XS: '158px',
  S: '332px',
  M: '332px',
  L: '680px',
  XL: '680px'
}

export const BOX_HEIGHTS: Record<CardBoxSize, string> = {
  XS: '158px',
  S: '158px',
  M: '332px',
  L: '486px',
  XL: '576px'
}

export const cardBoxSizes: Record<CardBoxSize, SxProps<Theme>> = {
  XS: {
    width: BOX_WIDTHS.XS,
    height: BOX_HEIGHTS.XS
  },
  S: {
    width: BOX_WIDTHS.S,
    height: BOX_HEIGHTS.S
  },
  M: {
    minWidth: BOX_WIDTHS.M,
    height: BOX_HEIGHTS.M
  },
  L: {
    minWidth: BOX_WIDTHS.L,
    height: BOX_HEIGHTS.L
  },
  XL: {
    minWidth: BOX_WIDTHS.XL,
    height: BOX_HEIGHTS.XL
  }
}
